export default __webpack_public_path__ + "static/media/4.f7b52834.png";